import { useParams } from 'react-router-dom';
import { BsShieldLockFill } from 'react-icons/bs';
import RapydInlineCheckout from './RapydInlineCheckout';
import { CHECKOUT_API_BASE_URL } from '../../services/apiService';
import './CheckoutPage.css';

/**
 * "Finish 3DS" page for the direct-card (card-via-API) Collect Group flow. The card was already
 * submitted to Rapyd server-side, so there is nothing to enter here — this page just hosts the bank
 * 3DS challenge inside our own iframe and polls for the outcome.
 *
 * The whole point: because the challenge runs in an iframe on our origin, Rapyd's post-challenge
 * redirect to the acquirer's return URL is caught by that acquirer's `frame-ancestors 'self'` inside
 * the (now dead) frame — never top-level — so the shopper never lands on a Collect Group page.
 * RapydInlineCheckout in `resume` mode does all of that; this is just its shell.
 */
export default function CollectCard3dsPage() {
  const { transactionId = '' } = useParams<{ transactionId: string }>();
  const paymentUrl = `${CHECKOUT_API_BASE_URL}/payments/checkout/${encodeURIComponent(transactionId)}`;

  return (
    <div className="checkout-screen text-foreground" data-theme="light">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '14px' }}>
        <div className="checkout-card checkout-card--rapyd">
          {transactionId ? (
            <RapydInlineCheckout transactionId={transactionId} paymentUrl={paymentUrl} resume />
          ) : (
            <p className="checkout-field-err" style={{ textAlign: 'center' }}>
              This payment link is invalid.
            </p>
          )}
          <div className="checkout-footer-note">
            <BsShieldLockFill /> Payments are encrypted and securely processed
          </div>
        </div>
      </div>
    </div>
  );
}
